export default "__VITE_ASSET__BbzIJ1ro__"